// Types
import mixins from"vue-typed-mixins";// Enums
import{Modals}from"../../enums/Modals";// Mixins
import CartModalEvents from"./CartModalEvents";// Components
import{CartModalView}from"../overridableComponents";const CartModal=mixins(CartModalEvents).extend({components:{CartModalView},provide(){return{isCartView:!0}},render(){const a=arguments[0];return a(CartModalView,{on:{close:()=>{this.$modal.hide(Modals.Cart)}}})}});export default CartModal;